<div class="show-list-obj">
  <div class="loading-spinner" *ngIf="loading">
    <mat-spinner [diameter]="30"></mat-spinner>
  </div>
  <div *ngIf="initialList! && initialList!.length > 0 && !loading">
    <mat-progress-bar
      class="list-obj-progress-bar"
      mode="determinate"
      [value]="percent"
    ></mat-progress-bar>
    <div class="progress-bar-subtitle">
      <p>{{ sumtext }}</p>
      <p>{{ visualized }}/{{ elegible }}</p>
    </div>
    <p class="text-list-object">{{ textlist }}</p>
    <div class="searchbar-occasion-card">
      <app-search-bar
        [cssClass]="'width: 100% !important'"
        actionText="Pesquisar"
        placeholder="{{ placeholder }}"
        (search)="filter($event)"
      ></app-search-bar>
      <div *ngFor="let userItem of dynamicList!">
        <app-user-item [userItem]="userItem"></app-user-item>
      </div>
    </div>
  </div>
  <div *ngIf="initialList!.length == 0 && !loading" class="not-yet">
    Ainda não existem visualizações
  </div>
</div>
